import React from 'react';
import { SITE_CONTENT } from '../content';

// SVG Icons
const MapPinIcon = () => (
  <svg className="w-5 h-5 text-[#1a2e1a]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.242-4.243a8 8 0 1111.314 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const PhoneIcon = () => (
  <svg className="w-5 h-5 text-[#1a2e1a]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
  </svg>
);

const EnvelopeIcon = () => (
  <svg className="w-5 h-5 text-[#1a2e1a]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

const GetInTouch = () => {
  const git = SITE_CONTENT.pages?.contactUsPage?.getInTouch || {};
  const subtitle = git.subtitle || "Contact";
  const title = git.title || "Get in Touch with Nawabi";
  const description = git.description || "Whether it’s a grand wedding or a corporate event, our team is ready to deliver a royal culinary experience. Call or WhatsApp us to get your customized quote.";
  const addressLines = git.addressLines || ["Salem, Tamil Nadu", "We serve across Tamil Nadu"];
  const phone = git.phone || "+91 91502 99336";
  const email = git.email || "nawabicaterers.support@gmail.com";
  const image = git.image || "";

  return (
    <section className="bg-[#f0eee5] py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {/* Left Text Content */}
          <div className="flex flex-col justify-center max-w-lg">
            <p className="text-[#1a2e1a] text-xs font-bold tracking-[0.25em] uppercase mb-4">
              {subtitle}
            </p>
            <h2 className="text-[#1a2e1a] text-4xl sm:text-5xl font-semibold mb-6">
              {title}
            </h2>
            <p className="text-[#7a7a68] text-sm sm:text-base leading-relaxed mb-10">
              {description}
            </p>

            <div className="space-y-6">
              {/* Address */}
              <div className="flex items-start gap-4">
                <div className="mt-0.5">
                  <MapPinIcon />
                </div>
                <div>
                  <p className="text-[#7a7a68] text-sm font-semibold mb-1">
                    {addressLines[0]}
                  </p>
                  <p className="text-[#7a7a68] text-sm font-semibold">
                    {addressLines[1]}
                  </p>
                </div>
              </div>

              {/* Phone */}
              <div className="flex items-center gap-4">
                <PhoneIcon />
                <p className="text-[#7a7a68] text-sm font-semibold">
                  {phone}
                </p>
              </div>

              {/* Email */}
              <div className="flex items-center gap-4">
                <EnvelopeIcon />
                <p className="text-[#7a7a68] text-sm font-semibold">
                  {email}
                </p>
              </div>
            </div>
          </div>

          {/* Right Image Content */}
          <div className="w-full">
            <div className="relative aspect-[4/3] w-full overflow-hidden shadow-sm bg-gray-200">
              <img 
                src={image} 
                alt={title} 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default GetInTouch;
